import { useDarkMode } from "../../../context/ThemeContext";

export default function PagosSection() {
  const { isDarkMode } = useDarkMode();

  const themeClasses = {
    bg: isDarkMode ? "bg-dark-bg" : "bg-white",
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
    cardBg: isDarkMode ? "bg-dark-surface" : "bg-white",
    cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  };

  return (
    <div className="w-full h-full p-6 overflow-auto">
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className={`text-2xl font-bold ${themeClasses.text}`}>
              Gestión de Pagos
            </h1>
            <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
              Registra y administra los pagos de las compañías
            </p>
          </div>
          <button className="flex items-center space-x-2 px-4 py-2 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-xl transition-all font-medium shadow-lg">
            <i className="ri-add-line"></i>
            <span>Nuevo Pago</span>
          </button>
        </div>
      </div>

      <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-6`}>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <i className={`ri-money-dollar-circle-line text-6xl ${themeClasses.textSecondary} mb-4`}></i>
            <p className={`text-lg ${themeClasses.textSecondary}`}>
              No hay pagos registrados
            </p>
            <p className={`text-sm ${themeClasses.textSecondary} mt-2`}>
              Selecciona una compañía y registra el primer pago
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
